import(/* webpackMode: "eager", webpackExports: ["IntroductionSection"] */ "/builds/tradingvalley-frontend/growin/apps/web/features/technology/components/IntroductionSection.tsx");
;
import(/* webpackMode: "eager" */ "/builds/tradingvalley-frontend/growin/apps/web/public/technology/main.webp");
;
import(/* webpackMode: "eager" */ "/builds/tradingvalley-frontend/growin/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/builds/tradingvalley-frontend/growin/node_modules/react-wrap-balancer/dist/index.mjs");
